// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import React, { FC, useContext } from "react";

export interface BrandDetailsPageContainerProps extends WidgetProps {}

export interface BrandDetailsPageContainerStyles {
    loadingOverlay?: LoadingOverlayProps;
}

export const brandDetailsPageContainerStyles: BrandDetailsPageContainerStyles = {};

const styles = brandDetailsPageContainerStyles;

const BrandDetailsPageContainer: FC<BrandDetailsPageContainerProps> = ({ id }) => {
    const brandDataView = useContext(BrandStateContext);

    return (
        <DataViewLoadingOverlay dataView={brandDataView} {...styles.loadingOverlay}>
            <Zone contentId={id} zoneName="Content" />
        </DataViewLoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Brand Details",
        allowedContexts: ["BrandDetailsPage"],
    },
};
export default widgetModule;
